import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TeachersPage from './pages/TeachersPage';
import ParentsPage from './pages/ParentsPage';
import ThemePage from './pages/ThemePage';
import DownloadPage from './pages/DownloadPage';
import ScrollToTop from './components/common/ScrollToTop';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/teachers" element={<TeachersPage />} />
        <Route path="/parents" element={<ParentsPage />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/" element={<Navigate to="/theme/fractions" />} />
        <Route path="/theme/:themeId" element={<ThemePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;